import { render, staticRenderFns } from "./PosInvoice.vue?vue&type=template&id=9d61d3f0&"
import script from "./PosInvoice.vue?vue&type=script&lang=js&"
export * from "./PosInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports